// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3354":"a6f71523788caff5","4803":"e2dba7012be6e3c3","7997":"48435533e8fef4d0","9365":"296416259ce9770a"}[chunkId] + ".css";
};